import { render, staticRenderFns } from "./slope-paicha-detail.vue?vue&type=template&id=5b8778b0"
import script from "./slope-paicha-detail.vue?vue&type=script&lang=js"
export * from "./slope-paicha-detail.vue?vue&type=script&lang=js"
import style0 from "./slope-paicha-detail.vue?vue&type=style&index=0&id=5b8778b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports